export function cloneRegexWithExtraFlag(input: RegExp, addedFlag: string): RegExp {
  const pattern = input.source;
  const flags = [...new Set(input.flags + addedFlag)].join('');

  return new RegExp(pattern, flags);
}
